/* eslint-disable import/no-cycle */
/**
 * Vuex
 *
 * @library
 *
 * https://vuex.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue';
import Vuex from 'vuex';

// Store functionality
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

// Modules
import auth from './modules/auth';
import tags from './modules/tags';
import companies from './modules/companies';
import posts from './modules/posts';
import postsLikeUnlike from './modules/postsLikeUnlike';
import comments from './modules/comments';
import user from './modules/user';
import meetingPlanner from './modules/meetingPlanner';
import notifications from './modules/notifications';
import network from './modules/network';
import events from './modules/events';
import awards from './modules/awards';
import messages from './modules/messages';
import globalStyles from './modules/globalStyles';
import advertisement from './modules/advertisement';
import invoice from './modules/invoice';
import core from './modules/core';
import mediaChannels from './modules/mediaChannels';
import mediaArchive from './modules/mediaArchive';
import menus from './modules/menus';
import aiChat from './modules/aiChat';
import uploadImg from './modules/uploadImg';

const state = {
  alert: {
    message: null,
    type: null,
    data: null,
  },
  loading: false,
  isMobileScreen: false,
  socketError: null,
  loadingMessage: ''
};

Vue.use(Vuex);


const { Store } = Vuex;
const store = new Store({
  state,
  getters,
  mutations,
  actions,
  modules: {
    auth,
    tags,
    companies,
    posts,
    postsLikeUnlike,
    invoice,
    comments,
    user,
    meetingPlanner,
    notifications,
    network,
    events,
    awards,
    messages,
    globalStyles,
    advertisement,
    core,
    mediaChannels,
    mediaArchive,
    menus,
    aiChat,
    uploadImg,
  },
});
export default store;
